import { useMemo, useState } from 'react';
import { IoMdClose, IoMdMenu } from 'react-icons/io';
import { useWindowDimensions } from '../hooks/useWindowDimensions';

export default function Header() {
  const { width } = useWindowDimensions();
  const [openMenu, setOpenMenu] = useState(false);

  const menu = useMemo(() => {
    return (
      <ul className='flex flex-col md:flex-row font-light items-start md:items-center text-nowrap italic font-serif gap-4 md:gap-16'>
        <li>
          <a
            className='hover:underline'
            href='#us'
            onClick={() => setOpenMenu(false)}
          >
            loren + robbie
          </a>
        </li>
        <li>
          <a
            className='hover:underline'
            href='#photos'
            onClick={() => setOpenMenu(false)}
          >
            photos
          </a>
        </li>
        <li>
          <a
            className='hover:underline'
            href='#lodging'
            onClick={() => setOpenMenu(false)}
          >
            lodging
          </a>
        </li>
        <li>
          <a
            className='hover:underline'
            href='#travel'
            onClick={() => setOpenMenu(false)}
          >
            travel
          </a>
        </li>
        <li>
          <a
            className='hover:underline'
            href='#schedule'
            onClick={() => setOpenMenu(false)}
          >
            schedule
          </a>
        </li>
        <li>
          <a
            className='hover:underline'
            href='#faq'
            onClick={() => setOpenMenu(false)}
          >
            q + a
          </a>
        </li>
        <li>
          <a
            className='hover:underline'
            href='https://registry.theknot.com/robert-chatterton-loren-genrich-september-2025-ma/70867962'
          >
            registry
          </a>
        </li>
        <li>
          <a
            className='hover:underline'
            href='https://www.theknot.com/us/robert-chatterton-and-loren-genrich-sep-2025'
          >
            rsvp
          </a>
        </li>
      </ul>
    );
  }, []);

  return (
    <>
      <div className='fixed top-0 left-0 w-full h-[60px] gap-10 shadow-sm shadow-slate-300 z-100 bg-white/90'>
        <div className='h-full mx-10 md:mx-40 flex flex-row items-center justify-end md:justify-center'>
          {width < 768 ? (
            <button onClick={() => setOpenMenu(true)}>
              <IoMdMenu size={32} />
            </button>
          ) : (
            menu
          )}
        </div>
      </div>

      {openMenu && (
        <div className='bg-black fixed top-0 left-0 w-screen h-screen z-20 flex flex-row justify-center items-start pt-16 px-10 text-white A'>
          {menu}
          <div className='flex-1' />
          <button
            className='hover:bg-slate-800 rounded-full'
            onClick={() => setOpenMenu(false)}
          >
            <IoMdClose size={32} />
          </button>
        </div>
      )}
    </>
  );
}
